import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {CoreState} from './core.reducer';
import {IDataTimeStamps} from '../models/data-time-stamps';

export const selectCoreState = createFeatureSelector<CoreState>('core');

// ====================================================================================================
// Get Image URL
// ====================================================================================================
export const selectImageURL = (image: string): MemoizedSelector<CoreState, string> => createSelector(
  selectCoreState,
  (state: CoreState): string | undefined => {
    if (state.images[image]) {
      return state.images[image];
    }
    return undefined;
  },
);

// ====================================================================================================
// User Messages
// ====================================================================================================
export const selectUserMessageCount = createSelector(
  selectCoreState,
  (state: CoreState) => state.userMessagesCount,
);

export const selectUserMessages = createSelector(
  selectCoreState,
  (state: CoreState) => state.userMessages,
);

export const selectFromAppQueue = createSelector(
  selectCoreState,
  (state: CoreState) => state.fromAppQueue,
);

export const selectIsFromAppQueueLoading = createSelector(
  selectCoreState,
  (state: CoreState) => state.isFromAppQueueLoading,
);

export const selectDataTimestamps = createSelector(
  selectCoreState,
  (state: CoreState) => state.dataTimeStamps,
);

export const selectDataTimestampsForSelectedStore = (storeId: string): MemoizedSelector<object, IDataTimeStamps> => createSelector(
  selectCoreState,
  (state: CoreState) => state.dataTimeStamps[storeId],
);

